// extracted by mini-css-extract-plugin
export default {"link":"Navigation_link__9yoF6","activeLink":"Navigation_activeLink__VVoBh Navigation_link__9yoF6"};